var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 40.625H45.8327M4.16602 28.125H16.1452M33.8535 28.125H45.8327",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1598 28.125C15.8852 27.7924 15.6296 27.4447 15.3942 27.0833C14.1815 25.2247 13.5375 23.0526 13.541 20.8333C13.541 14.5052 18.6712 9.375 24.9994 9.375C31.3275 9.375 36.4577 14.5052 36.4577 20.8333C36.4624 23.495 35.536 26.0745 33.8389 28.125",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibra);
export default __webpack_public_path__ + "static/media/libra.80a3392bb8f636b3de4f72e6b1513ffe.svg";
export { ForwardRef as ReactComponent };